// extracted by mini-css-extract-plugin
export default {"tagsContainer":"tagsCell_tagsContainer__8rLRW","tag":"tagsCell_tag__lSOAy","removeBtn":"tagsCell_removeBtn__Yjl47"};